import {useState,useEffect}from"react";
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ItemImageGalleryEdit from '../../item/itemImageGalleryEdit';
import ItemValueEdit from '../../item/itemValueEdit';
import ItemCustomFieldEdit from '../../item/itemCustomFieldEdit';
import ItemNoteEdit from '../../item/itemNoteEdit';
import ItemSettingEdit from '../../item/itemSettingEdit';
import Select from "react-select";
import {all_routes} from "../../../../../feature-module/router/all_routes";
import ImageUploading from 'react-images-uploading';
import {Toaster} from 'react-hot-toast';
// -- biz9 --
import {UrlQuery} from "biz9-react-utility";
import {Str,Status_Type,DateTime} from "biz9-utility";
import {Image_Type,Image_Format,Image_Table,Image_Field,Image_Service,Image_Url,Image_Logic} from "biz9-image";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field,Portal_Remote_Image} from "biz9-portal-app";
import {Store_Field} from "biz9-store";
import {Config,Field,Message,Title} from "../../../../../constant";
import {Data,Dashboard,Image,Style,Toast_Message,Event,App} from "../../../../../project";
import {Data_Logic} from "biz9-data-app";
const Dashboard_App_Event_Edit = () => {
    const query = UrlQuery();
    const [val_id,setValId] = useState(query.get('id'));
    const [val_sub_page_title,setValSubPageTitle] =  useState("");
    const [val_tag,setValTag] = useState("");
    const [val_note,setValNote] = useState("");
    const [val_description,setValDescription] = useState("");
    const [val_title,setValTitle] = useState("");
    const [val_cost,setValCost] = useState("");
    const [val_old_cost,setValOldCost] = useState("");
    const [val_date,setValDate] = useState("");
    const [val_time,setValTime] = useState("");
    const [val_website,setValWebsite] = useState("");
    const [val_location,setValLocation] = useState("");
    const [val_meeting_link,setValMeetingLink] = useState("");
    const [custom_fields,setCustomFields] = useState([]);
    const [hide_btn_image_post,setHideBtnImagePost] = useState(false);
    const [image_gallerys,setImageGallerys] = useState([]);
    const [field_values,setFieldValues] = useState([]);
    const [images,setImages] = useState([]);
    const [image_primary,setImagePrimary] = useState([]);
    const image_max_count = 1;
    const [val_stock,setValStock] = useState(null);
    const [stocks,setStocks] = useState([]);
    const [val_type,setValType] = useState(null);
    const [types,setTypes] = useState([]);
    const [val_category,setValCategory] = useState(null);
    const [categorys,setCategorys] = useState([]);
    const [item,setItem] = useState(Data_Logic.get(Portal_Table.EVENT,val_id));
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            if(val_id){
            get_data();
            }
            },[val_id]);
    async function get_data()
    {
        const option = {category:Title.EVENT};
        const [response,data] = await Portal_Remote_CMS.get(App.get_url(Portal_Url.CMS_GET),Portal_Table.EVENT,val_id,option);
        bind_page(data[Portal_Type.ITEM]);
        bind_field(data[Portal_Type.ITEM]);
        bind_field_value(data[Portal_Type.ITEM]);
        bind_items(data);
        Toast_Message.dismiss();
    };
    async function bind_page(data) {
        setValSubPageTitle(data.title);
    };
    async function bind_field(data) {
        setItem(Data_Logic.clean(data));
        setValTitle(data.title);
        setValCost(data.cost);
        setValOldCost(data.old_cost);
        setValDate(data.date);
        setValTime(data.time);
        setValWebsite(data.website);
        setValLocation(data.location);
        setValMeetingLink(data.meeting_link);
        setValDescription(data.description);
        if(data.image_filename){
            setImagePrimary([{image_filename:data.image_filename}]);
            setHideBtnImagePost(true);
        }
    };
    async function bind_field_value(data) {
        setFieldValues(Data.bind_field_values(data));
    };
    async function bind_field_custom_field(data) {
        if(data.custom_fields){
            setCustomFields(data.custom_fields);
        }
    };
    async function onImagePrimaryChange(image_upload, addUpdateIndex){
        Toast_Message.loading(Message.SAVING);
        setHideBtnImagePost(true);
        let image = Data_Logic.get(Image_Table.IMAGE,0,{data:{base64:image_upload[0][Image_Field.BASE64],extension:Str.get_file_extension(image_upload[0][Image_Field.FILE][Image_Field.NAME])}});
        let option = {};
        let [response,data] = await Portal_Remote_Image.post(App.get_url(Portal_Url.IMAGE_POST),[image],option);
        if(response.status == Status_Type.SUCCESS){
            Toast_Message.success(response.message);
            setHideBtnImagePost(true);
            post_field(item,Image_Field.IMAGE_FILENAME,data[0].image_filename,{});
            setImagePrimary([data[0]]);
        }else{
            Toast_Message.error(response.message);
            setHideBtnImagePost(false);
        }
        Toast_Message.dismiss();
    };
    const onImagePrimaryDelete = () => {
        if (window.confirm(Message.CONFIRM)) {
            Toast_Message.loading(Message.DELETING);
            setHideBtnImagePost(false);
            setImagePrimary([]);
            post_field(item,Image_Field.IMAGE_FILENAME,'',{success_message:Message.DELETED});
        }
    };
    const update_title_field = (item,field,value,option) => {
        if(!option){
            option = {};
        }
        if(!Str.check_is_null(item[Portal_Field.TITLE_URL])){
            item[Portal_Field.TITLE_URL] = Str.get_title_url(value);
            post_field(item,field,value,option);
            bind_page(item);
        }
    };
    async function post_field(item,field,value,option){
        if(!value){
            value = '';
        }
        if(field == Portal_Field.TITLE && !Str.check_is_null(item[Portal_Field.TITLE])){
            item[Portal_Field.TITLE_URL] = Str.get_title_url(value);
        }
        option = option ? option : {required:false,success_message:''};
        if(value.trim() === '' && option.required) {
            Toast_Message.error(Str.get_title(field) + " " +Message.INPUT_REQUIRED);
        }else{
            Toast_Message.loading(Message.SAVING);
            item[field] = value;
            setItem(item);
            bind_page(item);
            let option_post = {overwrite:true,clean:true};
            const [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),Portal_Table.EVENT,item,option_post);
            if(!option.success_message){
                Toast_Message.success(response.message);
            }else{
                Toast_Message.success(option.success_message);
            }
        }
    };
    const handle_submit = (event) =>{
        event.preventDefault();
    };
    async function bind_items(data){
        //image_gallerys
        setImageGallerys(data[Image_Field.IMAGE_GALLERYS]);
        //type
        let set_types = Data.get_type_categorys(data[Portal_Type.TYPES],{blank:true});
        setTypes(set_types);
        setValType(set_types.find(option => option.label === data[Portal_Type.ITEM].type));
        //catetory
        let set_categorys = Data.get_type_categorys(data[Portal_Type.CATEGORYS],{blank:true});
        setCategorys(set_categorys);
        setValCategory(set_categorys.find(option => option.label === data[Portal_Type.ITEM].category));
        //stock
        let set_stocks = Event.get_stocks();
        setStocks(set_stocks);
        setValStock(set_stocks.find(option => option.value === data[Portal_Type.ITEM].stock));
        //custom_fields
        setCustomFields(Data.bind_custom_fields(data[Portal_Type.ITEM],data[Portal_Type.CUSTOM_FIELDS]));
    };
    const updateValTitle = (event) => {
        setValTitle(event.target.value);
    };
    const updateValDescription = (event) => {
        setValDescription(event.target.value);
    };
    const updateValTag = (event) => {
        setValTag(event.target.value);
    };
    const updateValCost = (event) => {
        setValCost(event.target.value);
    };
    const updateValOldCost = (event) => {
        setValOldCost(event.target.value);
    };
    const updateValWebsite = (event) => {
        setValWebsite(event.target.value);
    };
    const updateValMeetingLink = (event) => {
        setValMeetingLink(event.target.value);
        post_field(item,Field.MEETING_LINK,event.target.value,{});
    };
    const updateValLocation = (event) => {
        setValLocation(event.target.value);
    };
    const updateValDate = (event) => {
        setValDate(event.target.value);
    };
    const updateValTime = (event) => {
        setValTime(event.target.value);
    };
    const updateValStock = (selectedOption) => {
        setValStock(selectedOption);
        post_field(item,Store_Field.STOCK,selectedOption.value,{});
    };
    const updateValType = (selectedOption) => {
        setValType(selectedOption);
        post_field(item,Portal_Field.TYPE,selectedOption.label,{});
    };
    const updateValCategory = (selectedOption) => {
        setValCategory(selectedOption);
        post_field(item,Portal_Field.CATEGORY,selectedOption.label,{});
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper"> <div className="page-content content bg-light">
            <div className="row justify-content-center">
            <div className="col-lg-10">
            <div className="main-title mb-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="settings-info bg-white">
            <ul className="nav nav-tabs nav-tabs-bottom mb-4">
            <li className="nav-item">
            <Link to={all_routes.dashboard_app_event} className="nav-link" >
            {Dashboard.get_dash_edit_item_back_link(Portal_Table.EVENT)}
            </Link>
            </li>
            </ul>
            <div className="settings-page-lists">
            {/*TAB --- ITEM-CMS-START --- */}
            <ul className="settings-head nav nav-tabs" role="tablist">
                <li className="nav-item" role="presentation">
                <Link to="#" className="nav-link active" data-bs-toggle="tab" data-bs-target="#tab_general"
                aria-selected="false" role="tab" tabIndex={-1}>
                {Title.LABEL_CMS_TAB_GENERAL}
            </Link>
                </li>
                <li className="nav-item" role="presentation">
                <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_field" aria-selected="false"
                role="tab" tabIndex={-1}>
                {Title.LABEL_CMS_TAB_CUSTOM_FIELD}
            </Link>
                </li>
                <li className="nav-item" role="presentation">
                <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_image_gallery" aria-selected="false"
                role="tab" tabIndex={-1}>
                {Title.LABEL_CMS_TAB_IMAGE_GALLERY}
            </Link>
                </li>
                <li className="nav-item" role="presentation">
                <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_note" aria-selected="false"
                role="tab" tabIndex={-1}>
                {Title.LABEL_CMS_TAB_NOTE}
            </Link>
                </li>
                <li className="nav-item" role="presentation">
                <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_value" aria-selected="false"
                role="tab" tabIndex={-1}>
                {Title.LABEL_CMS_TAB_VALUE}
            </Link>
                </li>
                <li className="nav-item" role="presentation">
                <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_setting" aria-selected="false" role="tab"
                tabIndex={-1}>
                {Title.LABEL_CMS_TAB_SETTING}
            </Link>
                </li>
                </ul>
                {/*TAB --- ITEM-CMS-START --- */}
            </div>
                <div className="tab-content">
                {/* General Tab  */}
            <div className="tab-pane fade show active" id="tab_general" role="tabpanel">
                <div className="settings-card">
                <div className="settings-card-head bg-light">
                <h4>General</h4>
                </div>
                <form onSubmit={handle_submit}>
                <div className="settings-card-body">
                <div className="row">
                <div className="col-md-12">
                <div className="form-wrap">
                <ImageUploading
                value={image_primary}
            onChange={onImagePrimaryChange}
            maxNumber={image_max_count}
            dataURLKey={Image_Field.BASE64}>
            {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    isDragging,
                    dragProps,
                    }) => (
                        <div className="upload__image-wrapper">
                        <button hidden={hide_btn_image_post} className="btn btn-secondary mb-2"
                        style={isDragging ? { color: 'red' } : undefined} onClick={() =>  onImageUpload()}
                        {...dragProps} >
                        Image
                        </button>
                        &nbsp;
                        {imageList.map((image, index) => (
                                    <div key={index} className="image-item">
                                    <img  src={Image.get_url(image.image_filename,Image_Format.SQUARE_THUMB)} alt=""  height="200" width="200" />
                                    <div className="image-item__btn-wrapper">
                                    <Link onClick={() => onImagePrimaryDelete() } to="#" className="mb-2" >
                                    <FeatherIcon icon="trash-2" />
                                    </Link>
                                    </div>
                                    </div>
                                    ))}
                        </div>
                        )}
            </ImageUploading>
                </div>
                </div>
                <div className="col-md-12">
                <div className="form-wrap mb-3">
                <label className="mb-1 fw-medium text-dark">
                {" "}
            Title{" "}
            <span className="text-primary">*</span>
                </label>
                <input value={val_title} onChange={updateValTitle} type="text" className="form-control" onBlur={() => update_title_field(item,Portal_Field.TITLE,val_title,{required:true})} />
                </div>
                </div>

                <div className="col-md-6">
                <div className="form-wrap">
                <label className="mb-1 fw-medium text-dark">
                {" "}
            Type{" "}
            </label>
                <Select classNamePrefix="react-select" className="select" styles={Style.customStyles} options={types} value={val_type} onChange={updateValType} />
                </div>
                </div>

                <div className="col-md-6">
                <div className="form-wrap">
                <label className="form-label mb-1 fw-medium text-dark">
                Category <span className="text-primary">*</span>
                </label>
                <Select classNamePrefix="react-select" className="select" styles={Style.customStyles} options={categorys} value={val_category} onChange={updateValCategory} />
                </div>
                </div>

                <div className="col-md-12">
                <div className="form-wrap mb-3">
                <label className="form-label mb-1 fw-medium text-dark">
                Stock <span className="text-primary">*</span>
                </label>
                <Select classNamePrefix="react-select" className="select" styles={Style.customStyles} options={stocks} value={val_stock} onChange={updateValStock} />
                </div>
                </div>

                <div className="col-md-6">
                <div className="form-wrap">
                <label className="form-label mb-1 fw-medium text-dark">
                Cost <span className="text-primary">*</span>
                </label>
                <input value={val_cost} onChange={updateValCost} type="text" className="form-control"  onBlur={() => post_field(item,Store_Field.COST,val_cost,{required:false})} />
                </div>
                </div>

                <div className="col-md-6">
                <div className="form-wrap">
                <label className="form-label mb-1 fw-medium text-dark">
                Old Cost <span className="text-primary">*</span>
                </label>
                <input value={val_old_cost} onChange={updateValOldCost} type="text" className="form-control" onBlur={() => post_field(item,Store_Field.OLD_COST,val_old_cost,{required:false})}/>
                </div>
                </div>

                <div className="col-md-6">
                <div className="form-wrap mb-3">
                <label className="mb-1 fw-medium text-dark">
                {" "}
            Date{" "}
            <span className="text-primary">*</span>
                </label>
                <input value={val_date} onChange={updateValDate} type="date" className="form-control" onBlur={() => post_field(item,Field.DATE,val_date,{required:false})}/>
                </div>
                </div>
                <div className="col-md-6">
                <div className="form-wrap mb-3">
                <label className="mb-1 fw-medium text-dark">
                {" "}
            Time{" "}
            <span className="text-primary">*</span>
                </label>
                <input value={val_time} onChange={updateValTime} type="time" className="form-control"  onBlur={() => post_field(item,Field.TIME,val_time,{required:false})}/>
                </div>
                </div>
                <div className="col-md-6">
                <div className="form-wrap mb-3">
                <label className="mb-1 fw-medium text-dark">
                {" "}
            Website{" "}
            <span className="text-primary">*</span>
                </label>
                <input value={val_website} onChange={updateValWebsite} onBlur={() => post_field(item,Field.WEBSITE,val_website,{})} type="text" className="form-control" />
                </div>
                </div>
                <div className="col-md-6">
                <div className="form-wrap mb-3">
                <label className="mb-1 fw-medium text-dark">
                {" "}
            Meeting Link{" "}
            <span className="text-primary">*</span>
                </label>
                <input value={val_meeting_link} onChange={updateValMeetingLink} type="text" className="form-control" onBlur={() => post_field(item,Field.MEETING_LINK,val_meeting_link,{})} />
                </div>
                </div>
                <div className="col-md-12">
                <div className="form-wrap mb-3">
                <label className="mb-1 fw-medium text-dark">
                {" "}
            Location{" "}
            <span className="text-primary">*</span>
                </label>
                <input value={val_location} onChange={updateValLocation} type="text" onBlur={() => post_field(item,Field.LOCATION,val_location,{})} className="form-control" />
                </div>
                </div>
                <div className="col-md-12">
                <div className="form-wrap mb-3">
                <label className="mb-1 fw-medium text-dark">
                {" "}
            Description{" "}
            </label>
                <input value={val_description} onChange={updateValDescription} onBlur={() => post_field(item,Field.DESCRIPTION,val_description,{})} type="text" className="form-control" />
                </div>
                </div>
                </div>


                </div>
                </form>
                </div>
                </div>
                {/* /General Tab  */}

            {/* Image_Gallery Tab */}
            <div className="tab-pane fade" id="tab_image_gallery" role="tabpanel">
                <ItemImageGalleryEdit onUpdate={setImageGallerys} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} image_gallerys={image_gallerys} parent_id={val_id} parent_table={Portal_Table.BLOG_POST} />
                </div>
                {/* Image_Gallery Tab */}

            {/* Field Tab */}
            <div className="tab-pane fade" id="tab_field" role="tabpanel">
                <ItemCustomFieldEdit custom_fields={custom_fields} item={item} onItemUpdate={post_field} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
                </div>
                {/* Field Tab */}
            {/* Value Tab */}
            <div className="tab-pane fade" id="tab_value" role="tabpanel">
                <ItemValueEdit field_values={field_values} item={item} onFieldValuesUpdate={setFieldValues} onItemUpdate={setItem} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
                </div>
                {/* Value Tab */}
            {/* Note Tab */}
            <div className="tab-pane fade" id="tab_note" role="tabpanel">
                <ItemNoteEdit item={item} onItemUpdate={post_field} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
                </div>
                {/* Note Tab */}
            {/* Setting Tab */}
            <div className="tab-pane fade" id="tab_setting" role="tabpanel">
                <ItemSettingEdit item={item} onItemUpdate={post_field} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
                </div>
                {/* Setting Tab */}
            </div>
            {/* /Page Content */}
            </div>
                </div>
                </div>
                </div>
                </div>
                {/* /Page Content */}
            </>
                );
};
export default Dashboard_App_Event_Edit;
